export { shellCurl } from './curl.js';
